var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.995 7.695a.948.948 0 0 0 .708-.28.975.975 0 0 0 .276-.713v-.311l-.216-3.327 2.254 2.393L6.8 8.27a.923.923 0 0 0 .696.287c.304 0 .558-.094.762-.281a.953.953 0 0 0 .305-.736c0-.144-.026-.28-.078-.407a1.002 1.002 0 0 0-.222-.335L5.468 4.009l-2.41-2.25 3.358.216h.3c.287 0 .53-.092.725-.276a.925.925 0 0 0 .294-.706.944.944 0 0 0-.294-.712A1.009 1.009 0 0 0 6.716 0H1.739C1.187 0 .759.152.456.455.152.758 0 1.185 0 1.735v4.967a.97.97 0 0 0 .995.993ZM11.285 18h4.976c.552 0 .98-.152 1.283-.455.304-.303.456-.73.456-1.28v-4.967a.969.969 0 0 0-.995-.993.964.964 0 0 0-.983.993v.311l.227 3.327-2.254-2.393L11.2 9.73a.923.923 0 0 0-.696-.287c-.304 0-.558.094-.761.281a.953.953 0 0 0-.306.736c0 .144.026.28.078.407.052.128.126.24.222.335l2.794 2.789 2.41 2.25-3.346-.216h-.312a1 1 0 0 0-.719.276.974.974 0 0 0-.3.706c0 .287.098.524.294.712.196.187.438.281.726.281Z",
    fill: "#014152"
  })));
};

export default SvgExpand;